import styled from "@emotion/styled";
import {
  CENTER,
  LEFT,
  RIGHT,
} from "../../../TemplateBuilder/TemplateItemEditor/FormatEditor/constants";
import { TextAlign } from "../../../../../requests/templates/types";
import { StyledCompProps } from "../../../../../globalTypes/theme";

type ThWrapperProps = { textAlign: TextAlign };
export const ThWrapper = styled.div<ThWrapperProps>`
  justify-content: ${({ textAlign }) => {
    switch (textAlign) {
      case LEFT:
        return "flex-start";
      case RIGHT:
        return "flex-end";
      case CENTER:
      default:
        return "center";
    }
  }};
  display: flex;
  flex-direction: row;
  align-items: center;
`;

type CheckboxThProps = { allowRowSelection: boolean };
export const CheckboxTh = styled.th<CheckboxThProps>`
  display: ${({ allowRowSelection }) =>
    allowRowSelection ? "table-cell" : "none"}};
`;

export const CheckboxDivTh = styled.div`
  border-bottom: 3px solid #e7e8ec;
  display: table-cell;
  text-align: left;
  padding: 5px;
  z-index: 10;
`;

export const StyledTh = styled.th<StyledCompProps>`
  color: ${({ theme }) => theme.colors.primaryColor};
`;

export const StyledDivTh = styled.div<StyledCompProps>`
  color: ${({ theme }) => theme.colors.primaryColor};
  background-color: white;
  display: table-cell;
  font-weight: bold;
`;

export const FlowioDivTableHead = styled.div`
  display: table-header-group;
  .tableHeaderRow {
    display: table-row;
  }
  .tableCol {
    display: table-cell;
    height: 55.2px;
    padding: 0 10px;
    vertical-align: middle;
    border-bottom: 3px solid #e7e8ec;
  }
`;

export const TableSortContainer = styled.div`
  display: inline-block;
  float: left;
`;
